import React, { Fragment, useEffect, useState } from 'react';
import { SvgIcon } from '@material-ui/core';
import styled from '@emotion/styled';
import { getTextColor } from '../../../../../style';
import { CustomStyledProps } from 'style/style';
import { isDarkMode } from 'utils/helpers';
import RequestInformationIcon from 'atoms/icons/RequestInformationIcon';

const commonStyles = () => ({
  fontSize: 26,
  color: isDarkMode() ? '#71B5E4' : '#0D5C93',
  stroke: isDarkMode() ? '#71B5E4' : '#0D5C93',
  strokeWidth: 0.5,
});

const RequestForInformationDiv = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: '20px',
});

const SpanText = styled('span')({
  fontSize: 16,
  lineHeight: '21px',
});

const DataProtectionStatus = styled('div')(
  () => ({
    paddingLeft: 20,
    fontSize: 13,
    marginTop: 10,
    ...getTextColor().DARK,
  }),
  ({ capitalize }: CustomStyledProps) => capitalize && { textTransform: 'capitalize' }
);

interface UserInfo {
  status?: string;
  file_link?: string;
}

const RequestForInformation = (props: { userInfo: UserInfo; requestUserInfo: () => void }): JSX.Element => {
  /* This component is created to handle the rendering of
       userinfo status whether they are in the following statuses:

       - Data not present(Dosen't do anything)
       - Data has been cleaned(show status of the userinfo)
       - Data has not been sent to user yet(userinfo === null)
       - Data is ready for download
       - Data is processing
    */
  const { userInfo, requestUserInfo } = props;
  const [myInfo, setUserInfo] = useState<UserInfo>({});

  useEffect(() => {
    setUserInfo(userInfo);
  }, [userInfo]);

  const RequestMenu = () => {
    return (
      <RequestForInformationDiv>
        <SpanText>Request Information</SpanText>
        <SvgIcon component={RequestInformationIcon} style={commonStyles()} />
      </RequestForInformationDiv>
    );
  };

  const isDownloadable = () => {
    if (myInfo.status === 'finished') {
      return (
        <div>
          {RequestMenu()}
          <DataProtectionStatus>
            Email Sent, or{' '}
            <a style={{ textDecoration: 'underline' }} href={myInfo.file_link}>
              Download
            </a>
          </DataProtectionStatus>
        </div>
      );
    } else if (myInfo.status === 'processing') {
      return (
        <div>
          {RequestMenu()}
          <DataProtectionStatus>Processing</DataProtectionStatus>
        </div>
      );
    } else {
      return (
        <Fragment>
          <RequestForInformationDiv>
            <SpanText>Request Information</SpanText>
            <SvgIcon component={RequestInformationIcon} style={commonStyles()} />
          </RequestForInformationDiv>
          <DataProtectionStatus capitalize>{myInfo.status}</DataProtectionStatus>
        </Fragment>
      );
    }
  };

  const evalUserInfoStatus = () => {
    return myInfo === null || myInfo.status === 'expired' || myInfo.status === 'failed';
  };

  const checkRequestForInfoStatus = () => {
    if (myInfo === undefined) {
      return null;
    } else if (evalUserInfoStatus()) {
      requestUserInfo();
    }
  };

  if (myInfo === undefined || evalUserInfoStatus()) {
    return (
      <div style={{ width: '100%' }}>
        <RequestForInformationDiv onClick={checkRequestForInfoStatus}>
          <SpanText>Request Information</SpanText>
          <SvgIcon component={RequestInformationIcon} style={commonStyles()} />
        </RequestForInformationDiv>
      </div>
    );
  } else {
    return <div style={{ width: '100%' }}>{isDownloadable()}</div>;
  }
};

export default RequestForInformation;
